<template>
  <Short_Header_AS />

  <!-- Works Banner -->
  <section>
    <div class="banner-home-header">
      <div class="container">
        <div
          loading="lazy"
          class="img-banner-home-header"
          :style="{
            backgroundImage: `url(${require('@/assets/talento_agv/img/banner-7.png')})`,
          }"
        ></div>
      </div>

      <div class="sobrefondo"></div>

      <div class="banner-content-works">
        <img
          v-if="isMobile"
          src="@/assets/talento_agv/img/home/Certificado-Sep-2024-2025.png"
          alt="Certificado"
          class="certificado-badge-mobile"
        />
        <h1 class="banner-title">Ofertas Laborales</h1>

        <form class="search-bar">
          <input
            v-model="search_query"
            type="text"
            placeholder="Busca por palabra clave"
          />

          <Select2
            ref="selPositions"
            v-model="selected_positions"
            :options="puestos"
            :settings="select2Settings()"
          />

          <Select2
            ref="selPlaces"
            v-model="selected_places"
            :options="lugares"
            :settings="select2Settings()"
          />

          <div class="search-icon-wrapper">
            <span class="d-flex align-items-center px-2" @click="localFilter">
              <i class="bx bx-search text-white fs-5 align-middle"></i>
            </span>
          </div>
        </form>
      </div>

      <img
        v-if="!isMobile"
        class="certificado-badge"
        src="@/assets/talento_agv/img/home/Certificado-Sep-2024-2025.png"
        alt="Certificado"
      />
    </div>
  </section>

  <section>
    <div class="container px-5 pt-5">
      <div class="row align-items-center justify-content-between">
        <div class="col-12 col-md-auto mb-3 mb-md-0">
          <span class="text-muted me-2">Todos los puestos de trabajo:</span>
          <strong class="me-3">{{ resultsCount }} Resultados</strong>
          <button class="btn-link-reset" type="button" @click="clearFilters">
            Limpiar filtros
          </button>
        </div>
        <div
          class="col-12 col-md-auto d-flex gap-4 justify-content-start justify-content-md-end"
        >
          <button
            class="topbar-link"
            type="button"
            @click="onFavorites"
            :disabled="!isUserLogged"
          >
            <i class="bx bx-heart me-1"></i>
            Mis Favoritos
          </button>
          <button
            class="topbar-link"
            type="button"
            @click="onApplications"
            :disabled="!isUserLogged"
          >
            <i class="bx bx-flag me-1"></i>
            Mis Postulaciones
          </button>
        </div>
      </div>
    </div>
  </section>

  <section>
    <div class="container p-5">
      <div class="row g-4">
        <template v-for="(job, index) in filtered_job_offers" :key="job.id">
          <div class="col-12 col-sm-6 col-md-6 col-lg-4">
            <!-- Cambiar img por job.s3_url -->
            <div class="content-job-card">
              <JobCard_AS
                :id="job.id"
                :title="job.work_pos"
                :vacancies="job.n_vacancy"
                :place="job.place"
                :image="job.s3_url"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
  </section>
  <div class="section-footer-ofertas-laborales"></div>
  <!-- Footer -->
  <Footer_AS />
</template>
<script>
import { nextTick } from "vue";
import axiosIns from "@/plugins/axios.js";
import Select2 from "vue3-select2-component";
import "select2/dist/css/select2.min.css";

import Footer_AS from "./components/Footer_AS.vue";
import JobCard_AS from "./components/JobCard_AS.vue";
import Short_Header_AS from "./components/Short_Header_AS.vue";

export default {
  components: {
    Footer_AS,
    JobCard_AS,
    Select2,
    Short_Header_AS,
  },

  data() {
    return {
      search_word: null,
      filtered_job_offers: [],
      all_job_offers: [],
      selected_positions: [],
      selected_places: [],
      search_query: "",
      searchOptions: ["Puesto", "Lugar"],
      puestos: [
        "Auxiliar",
        "Asistente",
        "Analista",
        "Supervisor",
        "Coordinador",
      ],
      lugares: ["Lima", "Chiclayo", "Olmos"],
      isMobile: window.innerWidth < 768,
    };
  },

  computed: {
    isUserLogged() {
      return !!localStorage.getItem("userData");
    },
    resultsCount() {
      return this.filtered_job_offers.length;
    },
  },

  created() {
    this.search_query = this.$route.query.search_word;
  },

  mounted() {
    this.getJobOffers();
    this.paintOne(this.$refs.selPositions, this.selected_positions, "Puesto");
    this.paintOne(this.$refs.selPlaces, this.selected_places, "Lugar");
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },

  watch: {
    selected_positions: {
      deep: true,
      handler() {
        this.paintOne(
          this.$refs.selPositions,
          this.selected_positions,
          "Puesto"
        );
      },
    },
    selected_places: {
      deep: true,
      handler() {
        this.paintOne(this.$refs.selPlaces, this.selected_places, "Lugar");
      },
    },
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    getJobOffers() {
      const yo = this;
      const config = {
        method: "get",
        url: "/talentoagv/readJobOffers/",
      };

      if (this.$store.getters.currentAdminLanguage == "es") {
        yo.language = "1";
      } else if (this.$store.getters.currentAdminLanguage == "en") {
        yo.language = "2";
      }

      axiosIns(config)
        .then(function (response) {
          if (response.data["is_error"] === false) {
            let resultado = response.data["result"];
            for (let r of resultado) {
              let fullName =
                r["name"] +
                " " +
                r["first_surname"] +
                " " +
                r["second_surname"];
              r["fullname"] = fullName;
            }
            yo.filtered_job_offers = resultado;
            yo.all_job_offers = resultado;

            if (yo.search_query) {
              yo.localFilter();
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    localFilter() {
      const query = this.search_query ? this.search_query.toLowerCase() : "";
      this.filtered_job_offers = this.all_job_offers.filter((offer) => {
        const matchesWorkPos =
          this.selected_positions.length === 0 ||
          this.selected_positions.some((pos) =>
            offer.work_pos.toLowerCase().includes(pos.toLowerCase())
          );

        const matchesPlace =
          this.selected_places.length === 0 ||
          this.selected_places.some((place) =>
            offer.place.toLowerCase().includes(place.toLowerCase())
          );

        const matchesQuery =
          !query ||
          offer.work_pos.toLowerCase().includes(query) ||
          offer.place.toLowerCase().includes(query);

        return matchesWorkPos && matchesPlace && matchesQuery;
      });
    },

    clearFilters() {
      this.selected_positions = [];
      this.selected_places = [];
      this.search_query = this.$route.query.search_word;
      this.filtered_job_offers = this.all_job_offers;
    },

    onFavorites() {
      // TODO: navega o abre modal
      console.log("Ir a favoritos");
    },

    onApplications() {
      // TODO: navega o abre modal
      console.log("Ir a postulaciones");
    },

    select2Settings() {
      return {
        multiple: true,
        closeOnSelect: false,
        width: "100%",
        allowClear: true,
        dropdownParent: document.body,
      };
    },

    paintOne(refComp, arr, placeholder) {
      nextTick(() => {
        const root = refComp?.$el || refComp;
        const rendered = root?.querySelector(".select2-selection__rendered");
        if (!rendered) return;

        let sum = rendered.querySelector(".select2-summary");
        if (!sum) {
          sum = document.createElement("span");
          sum.className = "select2-summary";
          rendered.appendChild(sum);
        }

        if (!arr || arr.length === 0) {
          sum.textContent = placeholder;
          sum.classList.add("is-placeholder");
          sum.title = "";
        } else {
          sum.textContent = arr.join(", ");
          sum.classList.remove("is-placeholder");
          sum.title = arr.join(", ");
        }
      });
    },

    handleResize() {
      this.isMobile = window.innerWidth < 768;
    },
  },
};
</script>
<style scoped src="./styles/shared_AS.css"></style>
<style scoped src="./styles/ofertas_laborales_AS.css"></style>
